import { Component } from 'react';

const CHUNK_ERROR_PATTERN = /Loading chunk|ChunkLoadError|dynamically imported module|Importing a module script failed/i;
const RELOAD_GUARD_KEY = 'pm_chunk_reload_attempted';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    // A stale cached page can reference a JS chunk that no longer exists after a
    // new deploy. One silent reload fetches the fresh index.html/chunks; the guard
    // stops an infinite reload loop if the error persists for another reason.
    if (CHUNK_ERROR_PATTERN.test(error?.message || '')) {
      let alreadyTried = false;
      try {
        alreadyTried = sessionStorage.getItem(RELOAD_GUARD_KEY) === '1';
        if (!alreadyTried) sessionStorage.setItem(RELOAD_GUARD_KEY, '1');
      } catch {
        // sessionStorage unavailable (private mode, etc.) — fall through to the fallback UI
      }
      if (!alreadyTried) {
        window.location.reload();
      }
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            minHeight: '60vh',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            padding: '0 24px',
            gap: 16,
          }}
        >
          <h2 style={{ color: 'var(--navy)', fontSize: 24, fontWeight: 700 }}>
            Something went wrong
          </h2>
          <p style={{ color: 'var(--gray-600)', fontSize: 15, maxWidth: 400 }}>
            Please reload the page. If the problem continues, try again in a moment.
          </p>
          <button
            onClick={() => window.location.reload()}
            style={{
              background: 'var(--teal)',
              color: 'var(--white)',
              border: 'none',
              borderRadius: 4,
              padding: '12px 28px',
              fontSize: 15,
              fontWeight: 700,
              cursor: 'pointer',
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
